import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useApiStore } from '@core/store';
import BaseSelector from '@/components/selectors/BaseSelector';

interface ShopSelectorProps {
    value: string | null;
    onChange: (shopId: string | null) => void;
    label?: string;
    disabled?: boolean;
    clearable?: boolean;
}

const ShopSelector: React.FC<ShopSelectorProps> = ({ value, onChange, label, disabled = false, clearable = false }) => {
    const { t } = useTranslation();
    const { shopIds, loadShopIds } = useApiStore();

    useEffect(() => {
        if (!shopIds || shopIds.length === 0) {
            loadShopIds();
        }
    }, []);

    const items = shopIds.map((shop) => ({ value: shop.id, text: shop.name }));

    return (
        <BaseSelector
            value={value}
            items={items}
            itemText="text"
            itemValue="value"
            label={label || t('shop')}
            placeholder={t('selectAShop')}
            disabled={disabled}
            onChange={(val) => onChange(val ?? null)}
            clearable={clearable}
            searchable
        />
    );
};

export default ShopSelector;
